import constants from '#packages/constants';
import type { EditorAPI } from '#packages/editorAPI';
import type { ComponentEditorMetaDataDefinition } from '../types';
import type { CompRef } from 'types/documentServices';
import experiments from 'experiment';
import { EditorParamsApiKey } from '#packages/apis';

const getOverridesWhenReferred = (editorAPI: EditorAPI, compRef: CompRef) => {
  const isBlocksComponent =
    editorAPI.components.isDescendantOfBlocksWidget(compRef);

  const gfpp = isBlocksComponent
    ? {
        disableActions: [constants.ROOT_COMPS.GFPP.ACTIONS.LAYOUT],
      }
    : {
        disableMainActionsByLabelKey: ['gfpp_mainaction_listsandgrids'],
        presetToBeMainAction: constants.ROOT_COMPS.GFPP.ACTIONS.LAYOUT,
      };

  return {
    gfpp,
  };
};
const getSkinParamsToIgnore = (editorAPI: EditorAPI) => {
  const isResponsiveEditor =
    editorAPI.host.getAPI(EditorParamsApiKey).isInsideEditorX;
  const isEditorX = experiments.isOpen(
    'specs.responsive-editor.filterRepeaterDesignParamsOnEditorX',
  );
  const isBlocks = experiments.isOpen(
    'specs.responsive-blocks.filterRepeaterDesignParamsOnBlocks',
  );
  return isResponsiveEditor && (isEditorX || isBlocks)
    ? ['shd', 'brw', 'rd', 'brd']
    : [];
};

const getA11yConfigurable = (editorAPI: EditorAPI, compRef: CompRef) => {
  function isSelectableRepeater() {
    return (
      editorAPI.components.getType(
        editorAPI.components.getChildren(compRef)[0],
      ) === constants.COMP_TYPES.SELECTABLE_CONTAINER
    );
  }

  return !isSelectableRepeater();
};

const metaData: ComponentEditorMetaDataDefinition = {
  selectedBeforeDescendants: true,
  focusable: true,
  allowConnectToDB: true,
  overridesWhenReferred: getOverridesWhenReferred,
  skinParamsToIgnore: getSkinParamsToIgnore,
  a11yConfigurable: getA11yConfigurable,
};

export default metaData;
